angular.module('zc.zenclerkS')
  .component('zcsNotificationAlert', {
    templateUrl: '/templates/zenclerk_s/directives/notification/notification-alert.html',
    controller: zcsSiteNotificationController
  });

zcsSiteNotificationController.$inject = ['$scope', '$state', '$translate', '$stateParams', 'Devise', 'FeatureNotification', 'ZcsLayout', 'ZcsOemService', 'ZcsProject'];
function zcsSiteNotificationController($scope, $state, $translate, $stateParams, Devise, FeatureNotification, ZcsLayout, ZcsOemService, ZcsProject) {
  const vm = this;

  /*
   * key: what will be saved to database
   * containerClass: alert-info, alert-success, etc
   * iconClass: icon
   * text: contents
   * linkAction: what happens when clicked
   * isActive: mostly time limit or can be used for external reason checks also
   * isVisible: on which states it will be shown
   */
  const NOTIFICATIONS = [
    {
      key: '20220922_aideal_incident_notification',
      containerClass: 'alert alert-info',
      iconClass: 'fa fa-bell-o',
      html: $translate.use() === 'ja'
        ? '現在、バナーは正常に配信されておりますが、データ集計に問題が発生しており、一部ダッシュボード上の数値が正しくない可能性があります。'
        : 'We are having data aggregation issue at the moment, numbers on the dashboard might not be correct, please come back later',
      allowDismiss: true,
      isActive: () => false,
      isVisible: () => false,
    },
    {
      key: '20191015_aideal_rebrand_notification',
      containerClass: 'alert alert-info',
      iconClass: 'fa fa-bell-o',
      html: $translate.instant('directives.notifications.alert1', { url: `<a href='https://www.appier.com/ja/news/appier-acquires-japan-based-emin/'>${$translate.instant('directives.common.here')}</a>` }),
      allowDismiss: true,
      isActive: () => true,
      isVisible: () => true,
    },
    {
      key: '20190927_consumption_tax_increase_notification',
      containerClass: 'alert alert-info',
      iconClass: 'fa fa-bell-o',
      text: `${$translate.instant('directives.notifications.alert2')}`,
      allowDismiss: true,
      isActive: () => true,
      // this line is unnecessary, because notifications aren't displayed for oem projects anyway but I'll just add it to be sure.
      isVisible: () => !vm.currentProject.is_oem
    },
  ];

  vm.$onInit = () => {
    vm.currentProject = undefined;
    vm.isDisabled = false;
    vm.dismiss = dismiss;
    vm.isAllowedToShow = isAllowedToShow;
    vm.ZcsOemService = ZcsOemService;

    $scope.$watch(() => ZcsOemService.get(), function(oemService) {
      // Avoid creating lots of meaningless shows when OEM
      // (this is because hide-when-oem is not ng-if but just hiding with css)
      if(oemService) {
        vm.isDisabled = true;
      } else {
        vm.isDisabled = false;
      }
    });

    // Get current project when stateParams change.
    // We cannot do this in isVisible or something because it's too heavy
    $scope.$watch(() => $stateParams.apikey, function(newval) {
      if(vm.isDisabled) { return }

      if(newval) {
        Devise.getCurrentUser()
          .then(user => {
            if(!user) { return }

            ZcsProject.get(user.id, $stateParams.apikey)
              .then(project => {
                vm.currentProject = project;
              });
          });
      }
    });

  };

  vm.$onChanges = () => {
    if(vm.isDisabled) { return }

    // need to ensure that user exists
    Devise.getCurrentUser()
      .then(user => {
        if(!user) { return }
        vm.notifications = [];

        _.each(NOTIFICATIONS, notification => {
        // Add when not read already
          if(!_.includes(user.read_notifications, notification.key) &&
            notification.isActive()) {
            vm.notifications.push(notification);
          }
        });
      });
  };

  function isAllowedToShow(notification) {
    const isVisible = notification.isVisible();

    // Only set as shown if the state we are in actually allows showing the notification
    if(isVisible &&
        !notification.__markedAsShown &&
        // NOTE: isDisabled for OEM checks to avoid creating notifications,
        // because when OEM, these are just hidden with css
        !vm.isDisabled) {

      FeatureNotification.markAsShown(notification)
        .finally(() => {
          notification.__markedAsShown = true;
        });

    }
    return isVisible;
  }

  function dismiss(notification) {
    vm.notifications = _.reject(vm.notifications, d => d === notification);
    FeatureNotification.markAsRead(notification);
    Devise.getCurrentUser()
      .then(user => {
        user.read_notifications.push(notification.key);
      });
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/notification/notification-alert.js